/* SUPER10 — eBay-style prev/next arrows on the product media gallery (desktop).
   Non-invasive: clicks Dawn's thumbnail buttons to switch the main image. */
(function () {
  function initGallery(gallery) {
    if (gallery.dataset.s10Arrows) return;
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item button.thumbnail')
    );
    if (thumbs.length < 2) return;

    var viewer = gallery.querySelector('.product__media-list') || gallery;
    viewer.classList.add('s10-gal-viewer');

    var current = thumbs.findIndex(function (t) {
      return t.getAttribute('aria-current') === 'true';
    });
    if (current < 0) current = 0;

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { current = i; });
    });

    function make(dir, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 's10-gal-arrow s10-gal-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.textContent = glyph;
      return b;
    }
    var prev = make('prev', '‹');
    var next = make('next', '›');

    function go(step) {
      current = (current + step + thumbs.length) % thumbs.length;
      thumbs[current].click();
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(1); });

    viewer.appendChild(prev);
    viewer.appendChild(next);
    gallery.dataset.s10Arrows = '1';
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
